@file:OptIn(InternalResourceApi::class)

package one.devsbox.www.www_portal.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/one.devsbox.www.www_portal.generated.resources/"

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_locations_detail_btn_delete: StringResource by lazy {
      StringResource("string:ui_locations_detail_btn_delete", "ui_locations_detail_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 20955, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20035, 46),
      ))
    }

@delegate:ResourceContentHash(-503_216_827)
internal val Res.string.ui_locations_detail_btn_edit: StringResource by lazy {
      StringResource("string:ui_locations_detail_btn_edit", "ui_locations_detail_btn_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21006, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20082, 44),
      ))
    }

@delegate:ResourceContentHash(1_383_998_125)
internal val Res.string.ui_locations_detail_delete_confirm_message: StringResource by lazy {
      StringResource("string:ui_locations_detail_delete_confirm_message", "ui_locations_detail_delete_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21051, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20127, 114),
      ))
    }

@delegate:ResourceContentHash(1_127_114_407)
internal val Res.string.ui_locations_detail_delete_confirm_title: StringResource by lazy {
      StringResource("string:ui_locations_detail_delete_confirm_title", "ui_locations_detail_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21170, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20242, 68),
      ))
    }

@delegate:ResourceContentHash(376_591_794)
internal val Res.string.ui_locations_detail_delete_failed: StringResource by lazy {
      StringResource("string:ui_locations_detail_delete_failed", "ui_locations_detail_delete_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21243, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20311, 77),
      ))
    }

@delegate:ResourceContentHash(1_305_446_188)
internal val Res.string.ui_locations_detail_devices_count: StringResource by lazy {
      StringResource("string:ui_locations_detail_devices_count", "ui_locations_detail_devices_count", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21325, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20389, 57),
      ))
    }

@delegate:ResourceContentHash(2_071_617_355)
internal val Res.string.ui_locations_detail_search_hint: StringResource by lazy {
      StringResource("string:ui_locations_detail_search_hint", "ui_locations_detail_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21387, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20447, 67),
      ))
    }

@delegate:ResourceContentHash(1_908_192_713)
internal val Res.string.ui_locations_details_indoor_nodes: StringResource by lazy {
      StringResource("string:ui_locations_details_indoor_nodes", "ui_locations_details_indoor_nodes", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21459, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20515, 57),
      ))
    }

@delegate:ResourceContentHash(-782_867_406)
internal val Res.string.ui_locations_details_offline_devices: StringResource by lazy {
      StringResource("string:ui_locations_details_offline_devices", "ui_locations_details_offline_devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21525, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20573, 64),
      ))
    }

@delegate:ResourceContentHash(1_221_464_412)
internal val Res.string.ui_locations_details_online_devices: StringResource by lazy {
      StringResource("string:ui_locations_details_online_devices", "ui_locations_details_online_devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21598, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20638, 63),
      ))
    }

@delegate:ResourceContentHash(1_624_471_103)
internal val Res.string.ui_locations_details_outdoor_nodes: StringResource by lazy {
      StringResource("string:ui_locations_details_outdoor_nodes", "ui_locations_details_outdoor_nodes", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21666, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20702, 62),
      ))
    }

@delegate:ResourceContentHash(1_816_220_427)
internal val Res.string.ui_locations_edit_btn_add_range: StringResource by lazy {
      StringResource("string:ui_locations_edit_btn_add_range", "ui_locations_edit_btn_add_range", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21733, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20765, 55),
      ))
    }

@delegate:ResourceContentHash(936_220_866)
internal val Res.string.ui_locations_edit_btn_save: StringResource by lazy {
      StringResource("string:ui_locations_edit_btn_save", "ui_locations_edit_btn_save", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21793, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20821, 42),
      ))
    }

@delegate:ResourceContentHash(-675_808_415)
internal val Res.string.ui_locations_edit_halted: StringResource by lazy {
      StringResource("string:ui_locations_edit_halted", "ui_locations_edit_halted", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21836, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20864, 56),
      ))
    }

@delegate:ResourceContentHash(267_520_369)
internal val Res.string.ui_locations_edit_label_address: StringResource by lazy {
      StringResource("string:ui_locations_edit_label_address", "ui_locations_edit_label_address", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21901, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20921, 63),
      ))
    }

@delegate:ResourceContentHash(-1_568_105_249)
internal val Res.string.ui_locations_edit_label_name: StringResource by lazy {
      StringResource("string:ui_locations_edit_label_name", "ui_locations_edit_label_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 21961, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20985, 56),
      ))
    }

@delegate:ResourceContentHash(-902_466_203)
internal val Res.string.ui_locations_edit_label_opening_hours: StringResource by lazy {
      StringResource("string:ui_locations_edit_label_opening_hours", "ui_locations_edit_label_opening_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22018, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21042, 65),
      ))
    }

@delegate:ResourceContentHash(1_911_406_153)
internal val Res.string.ui_locations_edit_placeholder_address: StringResource by lazy {
      StringResource("string:ui_locations_edit_placeholder_address", "ui_locations_edit_placeholder_address", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22084, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21108, 69),
      ))
    }

@delegate:ResourceContentHash(80_470_140)
internal val Res.string.ui_locations_edit_range_to: StringResource by lazy {
      StringResource("string:ui_locations_edit_range_to", "ui_locations_edit_range_to", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22154, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21178, 38),
      ))
    }

@delegate:ResourceContentHash(-1_733_012_182)
internal val Res.string.ui_locations_edit_remove_range: StringResource by lazy {
      StringResource("string:ui_locations_edit_remove_range", "ui_locations_edit_remove_range", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22193, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21217, 54),
      ))
    }

@delegate:ResourceContentHash(-1_222_290_261)
internal val Res.string.ui_locations_edit_time: StringResource by lazy {
      StringResource("string:ui_locations_edit_time", "ui_locations_edit_time", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22252, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21272, 38),
      ))
    }

@delegate:ResourceContentHash(-1_385_667_318)
internal val Res.string.ui_locations_listing_btn_new: StringResource by lazy {
      StringResource("string:ui_locations_listing_btn_new", "ui_locations_listing_btn_new", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22295, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21311, 48),
      ))
    }

@delegate:ResourceContentHash(-2_800_520)
internal val Res.string.ui_locations_listing_header_devices: StringResource by lazy {
      StringResource("string:ui_locations_listing_header_devices", "ui_locations_listing_header_devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22344, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21360, 55),
      ))
    }

@delegate:ResourceContentHash(81_821_120)
internal val Res.string.ui_locations_listing_header_id: StringResource by lazy {
      StringResource("string:ui_locations_listing_header_id", "ui_locations_listing_header_id", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22400, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21416, 42),
      ))
    }

@delegate:ResourceContentHash(-339_871_113)
internal val Res.string.ui_locations_listing_header_name_address: StringResource by lazy {
      StringResource("string:ui_locations_listing_header_name_address", "ui_locations_listing_header_name_address", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22443, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21459, 80),
      ))
    }

@delegate:ResourceContentHash(-1_131_027_589)
internal val Res.string.ui_locations_listing_search_placeholder: StringResource by lazy {
      StringResource("string:ui_locations_listing_search_placeholder", "ui_locations_listing_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22524, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21540, 63),
      ))
    }

@delegate:ResourceContentHash(-843_623_927)
internal val Res.string.ui_locations_listing_showing: StringResource by lazy {
      StringResource("string:ui_locations_listing_showing", "ui_locations_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22624, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21604, 84),
      ))
    }

@delegate:ResourceContentHash(-1_590_321_951)
internal val Res.string.ui_locations_splash_desc: StringResource by lazy {
      StringResource("string:ui_locations_splash_desc", "ui_locations_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22713, 216),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21689, 188),
      ))
    }

@delegate:ResourceContentHash(-1_977_843_466)
internal val Res.string.ui_locations_splash_title: StringResource by lazy {
      StringResource("string:ui_locations_splash_title", "ui_locations_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22930, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21878, 45),
      ))
    }

@delegate:ResourceContentHash(-1_429_762_933)
internal val Res.string.ui_login_access: StringResource by lazy {
      StringResource("string:ui_login_access", "ui_login_access", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 22976, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21924, 43),
      ))
    }

@delegate:ResourceContentHash(-1_515_607_493)
internal val Res.string.ui_login_btn_authorize: StringResource by lazy {
      StringResource("string:ui_login_btn_authorize", "ui_login_btn_authorize", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23020, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21968, 42),
      ))
    }

@delegate:ResourceContentHash(1_067_055_945)
internal val Res.string.ui_login_change_password_btn_cancel: StringResource by lazy {
      StringResource("string:ui_login_change_password_btn_cancel", "ui_login_change_password_btn_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23067, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22011, 51),
      ))
    }

@delegate:ResourceContentHash(-1_918_958_121)
internal val Res.string.ui_login_change_password_btn_confirm: StringResource by lazy {
      StringResource("string:ui_login_change_password_btn_confirm", "ui_login_change_password_btn_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23123, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22063, 56),
      ))
    }

@delegate:ResourceContentHash(-1_966_453_734)
internal val Res.string.ui_login_change_password_desc: StringResource by lazy {
      StringResource("string:ui_login_change_password_desc", "ui_login_change_password_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23180, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22120, 125),
      ))
    }

@delegate:ResourceContentHash(-1_507_393_802)
internal val Res.string.ui_login_change_password_error: StringResource by lazy {
      StringResource("string:ui_login_change_password_error", "ui_login_change_password_error", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23314, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22246, 74),
      ))
    }

@delegate:ResourceContentHash(1_010_528_118)
internal val Res.string.ui_login_change_password_label_new: StringResource by lazy {
      StringResource("string:ui_login_change_password_label_new", "ui_login_change_password_label_new", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23393, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22321, 58),
      ))
    }

@delegate:ResourceContentHash(-529_968_707)
internal val Res.string.ui_login_change_password_label_repeat: StringResource by lazy {
      StringResource("string:ui_login_change_password_label_repeat", "ui_login_change_password_label_repeat", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23452, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22380, 65),
      ))
    }

@delegate:ResourceContentHash(-178_330_454)
internal val Res.string.ui_login_change_password_placeholder_new: StringResource by lazy {
      StringResource("string:ui_login_change_password_placeholder_new", "ui_login_change_password_placeholder_new", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23522, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22446, 72),
      ))
    }

@delegate:ResourceContentHash(-1_082_015_208)
internal val Res.string.ui_login_change_password_placeholder_repeat: StringResource by lazy {
      StringResource("string:ui_login_change_password_placeholder_repeat", "ui_login_change_password_placeholder_repeat", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23599, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22519, 79),
      ))
    }

@delegate:ResourceContentHash(-53_236_595)
internal val Res.string.ui_login_change_password_title: StringResource by lazy {
      StringResource("string:ui_login_change_password_title", "ui_login_change_password_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23679, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22599, 58),
      ))
    }

@delegate:ResourceContentHash(508_698_892)
internal val Res.string.ui_login_invalid: StringResource by lazy {
      StringResource("string:ui_login_invalid", "ui_login_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23742, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22658, 52),
      ))
    }

@delegate:ResourceContentHash(-2_051_282_826)
internal val Res.string.ui_login_password: StringResource by lazy {
      StringResource("string:ui_login_password", "ui_login_password", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23799, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22711, 37),
      ))
    }

@delegate:ResourceContentHash(1_041_238_001)
internal val Res.string.ui_login_username: StringResource by lazy {
      StringResource("string:ui_login_username", "ui_login_username", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23837, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22749, 33),
      ))
    }

@delegate:ResourceContentHash(80_528_753)
internal val Res.string.ui_logout_dialog_btn_confirm: StringResource by lazy {
      StringResource("string:ui_logout_dialog_btn_confirm", "ui_logout_dialog_btn_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23875, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22783, 40),
      ))
    }

@delegate:ResourceContentHash(83_454_045)
internal val Res.string.ui_logout_dialog_btn_dismiss: StringResource by lazy {
      StringResource("string:ui_logout_dialog_btn_dismiss", "ui_logout_dialog_btn_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23916, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22824, 40),
      ))
    }

@delegate:ResourceContentHash(-2_062_536_096)
internal val Res.string.ui_logout_dialog_message: StringResource by lazy {
      StringResource("string:ui_logout_dialog_message", "ui_logout_dialog_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 23957, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22865, 76),
      ))
    }

@delegate:ResourceContentHash(-783_407_287)
internal val Res.string.ui_logout_dialog_title: StringResource by lazy {
      StringResource("string:ui_logout_dialog_title", "ui_logout_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24046, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22942, 38),
      ))
    }

@delegate:ResourceContentHash(262_444_405)
internal val Res.string.ui_resources_detail_aspect_ratio: StringResource by lazy {
      StringResource("string:ui_resources_detail_aspect_ratio", "ui_resources_detail_aspect_ratio", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24085, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22981, 56),
      ))
    }

@delegate:ResourceContentHash(-422_481_853)
internal val Res.string.ui_resources_detail_btn_convert_video: StringResource by lazy {
      StringResource("string:ui_resources_detail_btn_convert_video", "ui_resources_detail_btn_convert_video", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24146, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23038, 69),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_resources_detail_btn_delete: StringResource by lazy {
      StringResource("string:ui_resources_detail_btn_delete", "ui_resources_detail_btn_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24216, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23108, 46),
      ))
    }

@delegate:ResourceContentHash(2_102_303_880)
internal val Res.string.ui_resources_detail_btn_download: StringResource by lazy {
      StringResource("string:ui_resources_detail_btn_download", "ui_resources_detail_btn_download", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24267, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23155, 52),
      ))
    }

@delegate:ResourceContentHash(-1_833_084_223)
internal val Res.string.ui_resources_detail_conversion: StringResource by lazy {
      StringResource("string:ui_resources_detail_conversion", "ui_resources_detail_conversion", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24528, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23396, 54),
      ))
    }

@delegate:ResourceContentHash(-1_280_732_954)
internal val Res.string.ui_resources_detail_conversion_started: StringResource by lazy {
      StringResource("string:ui_resources_detail_conversion_started", "ui_resources_detail_conversion_started", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24320, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23208, 118),
      ))
    }

@delegate:ResourceContentHash(596_755_672)
internal val Res.string.ui_resources_detail_conversion_title: StringResource by lazy {
      StringResource("string:ui_resources_detail_conversion_title", "ui_resources_detail_conversion_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24455, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23327, 68),
      ))
    }

@delegate:ResourceContentHash(2_088_991_756)
internal val Res.string.ui_resources_detail_date_added: StringResource by lazy {
      StringResource("string:ui_resources_detail_date_added", "ui_resources_detail_date_added", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24583, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23451, 54),
      ))
    }

@delegate:ResourceContentHash(-24_625_281)
internal val Res.string.ui_resources_detail_delete_btn_confirm: StringResource by lazy {
      StringResource("string:ui_resources_detail_delete_btn_confirm", "ui_resources_detail_delete_btn_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24642, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23506, 54),
      ))
    }

@delegate:ResourceContentHash(1_573_769_046)
internal val Res.string.ui_resources_detail_delete_btn_dismiss: StringResource by lazy {
      StringResource("string:ui_resources_detail_delete_btn_dismiss", "ui_resources_detail_delete_btn_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24701, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23561, 58),
      ))
    }

@delegate:ResourceContentHash(-2_026_603_457)
internal val Res.string.ui_resources_detail_delete_confirm_message: StringResource by lazy {
      StringResource("string:ui_resources_detail_delete_confirm_message", "ui_resources_detail_delete_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24760, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23620, 122),
      ))
    }

@delegate:ResourceContentHash(105_616_997)
internal val Res.string.ui_resources_detail_delete_confirm_title: StringResource by lazy {
      StringResource("string:ui_resources_detail_delete_confirm_title", "ui_resources_detail_delete_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24891, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23743, 64),
      ))
    }

@delegate:ResourceContentHash(944_689_656)
internal val Res.string.ui_resources_detail_description: StringResource by lazy {
      StringResource("string:ui_resources_detail_description", "ui_resources_detail_description", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 24960, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23808, 55),
      ))
    }

@delegate:ResourceContentHash(-454_368_180)
internal val Res.string.ui_resources_detail_dominant_palette: StringResource by lazy {
      StringResource("string:ui_resources_detail_dominant_palette", "ui_resources_detail_dominant_palette", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25008, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23864, 68),
      ))
    }

@delegate:ResourceContentHash(1_132_501_738)
internal val Res.string.ui_resources_detail_duration: StringResource by lazy {
      StringResource("string:ui_resources_detail_duration", "ui_resources_detail_duration", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25077, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23933, 48),
      ))
    }

@delegate:ResourceContentHash(879_476_198)
internal val Res.string.ui_resources_detail_file_name: StringResource by lazy {
      StringResource("string:ui_resources_detail_file_name", "ui_resources_detail_file_name", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25126, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23982, 49),
      ))
    }

@delegate:ResourceContentHash(-1_551_940_619)
internal val Res.string.ui_resources_detail_file_size: StringResource by lazy {
      StringResource("string:ui_resources_detail_file_size", "ui_resources_detail_file_size", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25184, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24032, 49),
      ))
    }

@delegate:ResourceContentHash(1_661_036_776)
internal val Res.string.ui_resources_detail_file_type: StringResource by lazy {
      StringResource("string:ui_resources_detail_file_type", "ui_resources_detail_file_type", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25246, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24082, 49),
      ))
    }

@delegate:ResourceContentHash(-1_634_630_944)
internal val Res.string.ui_resources_detail_info: StringResource by lazy {
      StringResource("string:ui_resources_detail_info", "ui_resources_detail_info", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25304, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24132, 40),
      ))
    }

@delegate:ResourceContentHash(-579_069_472)
internal val Res.string.ui_resources_detail_metadata_tags: StringResource by lazy {
      StringResource("string:ui_resources_detail_metadata_tags", "ui_resources_detail_metadata_tags", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25345, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24173, 61),
      ))
    }

@delegate:ResourceContentHash(-609_707_740)
internal val Res.string.ui_resources_detail_no_description: StringResource by lazy {
      StringResource("string:ui_resources_detail_no_description", "ui_resources_detail_no_description", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25411, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24235, 74),
      ))
    }

@delegate:ResourceContentHash(-181_754_221)
internal val Res.string.ui_resources_detail_orientation: StringResource by lazy {
      StringResource("string:ui_resources_detail_orientation", "ui_resources_detail_orientation", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25478, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24310, 55),
      ))
    }

@delegate:ResourceContentHash(-1_461_880_855)
internal val Res.string.ui_resources_detail_pages: StringResource by lazy {
      StringResource("string:ui_resources_detail_pages", "ui_resources_detail_pages", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25534, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24366, 41),
      ))
    }

@delegate:ResourceContentHash(-576_114_565)
internal val Res.string.ui_resources_detail_resolution: StringResource by lazy {
      StringResource("string:ui_resources_detail_resolution", "ui_resources_detail_resolution", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25580, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24408, 54),
      ))
    }

@delegate:ResourceContentHash(-1_298_430_027)
internal val Res.string.ui_resources_detail_status_fail: StringResource by lazy {
      StringResource("string:ui_resources_detail_status_fail", "ui_resources_detail_status_fail", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25635, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24463, 47),
      ))
    }

@delegate:ResourceContentHash(2_129_101_214)
internal val Res.string.ui_resources_detail_status_processing: StringResource by lazy {
      StringResource("string:ui_resources_detail_status_processing", "ui_resources_detail_status_processing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25687, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24511, 61),
      ))
    }

@delegate:ResourceContentHash(422_955_991)
internal val Res.string.ui_resources_detail_status_ready: StringResource by lazy {
      StringResource("string:ui_resources_detail_status_ready", "ui_resources_detail_status_ready", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25741, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24573, 48),
      ))
    }

@delegate:ResourceContentHash(-394_292_674)
internal val Res.string.ui_resources_detail_technical_specs: StringResource by lazy {
      StringResource("string:ui_resources_detail_technical_specs", "ui_resources_detail_technical_specs", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25794, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24622, 63),
      ))
    }

@delegate:ResourceContentHash(-106_461_003)
internal val Res.string.ui_resources_detail_unknown: StringResource by lazy {
      StringResource("string:ui_resources_detail_unknown", "ui_resources_detail_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25870, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24686, 47),
      ))
    }

@delegate:ResourceContentHash(1_491_743_000)
internal val Res.string.ui_resources_listing_btn_upload: StringResource by lazy {
      StringResource("string:ui_resources_listing_btn_upload", "ui_resources_listing_btn_upload", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25918, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24734, 47),
      ))
    }

@delegate:ResourceContentHash(82_608_977)
internal val Res.string.ui_resources_listing_filter_opt_all: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_all", "ui_resources_listing_filter_opt_all", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 25970, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24782, 47),
      ))
    }

@delegate:ResourceContentHash(-1_064_683_175)
internal val Res.string.ui_resources_listing_filter_opt_horizontal: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_horizontal", "ui_resources_listing_filter_opt_horizontal", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26018, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24830, 66),
      ))
    }

@delegate:ResourceContentHash(384_645_533)
internal val Res.string.ui_resources_listing_filter_opt_image: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_image", "ui_resources_listing_filter_opt_image", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26085, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24897, 53),
      ))
    }

@delegate:ResourceContentHash(83_237_024)
internal val Res.string.ui_resources_listing_filter_opt_pdf: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_pdf", "ui_resources_listing_filter_opt_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26139, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24951, 47),
      ))
    }

@delegate:ResourceContentHash(-1_928_995_252)
internal val Res.string.ui_resources_listing_filter_opt_vertical: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_vertical", "ui_resources_listing_filter_opt_vertical", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26187, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24999, 60),
      ))
    }

@delegate:ResourceContentHash(1_085_756_160)
internal val Res.string.ui_resources_listing_filter_opt_video: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_opt_video", "ui_resources_listing_filter_opt_video", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26252, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25060, 53),
      ))
    }

@delegate:ResourceContentHash(-1_990_354_322)
internal val Res.string.ui_resources_listing_filter_orientation: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_orientation", "ui_resources_listing_filter_orientation", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26306, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25114, 63),
      ))
    }

@delegate:ResourceContentHash(394_632_241)
internal val Res.string.ui_resources_listing_filter_type: StringResource by lazy {
      StringResource("string:ui_resources_listing_filter_type", "ui_resources_listing_filter_type", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26370, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25178, 48),
      ))
    }

@delegate:ResourceContentHash(-673_813_401)
internal val Res.string.ui_resources_listing_no_resources_found: StringResource by lazy {
      StringResource("string:ui_resources_listing_no_resources_found", "ui_resources_listing_no_resources_found", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26419, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25227, 111),
      ))
    }

@delegate:ResourceContentHash(-61_401_431)
internal val Res.string.ui_resources_listing_search_pick_placeholder: StringResource by lazy {
      StringResource("string:ui_resources_listing_search_pick_placeholder", "ui_resources_listing_search_pick_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26551, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25339, 84),
      ))
    }

@delegate:ResourceContentHash(-1_847_630_584)
internal val Res.string.ui_resources_listing_search_placeholder: StringResource by lazy {
      StringResource("string:ui_resources_listing_search_placeholder", "ui_resources_listing_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26644, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25424, 59),
      ))
    }

@delegate:ResourceContentHash(-2_015_501_098)
internal val Res.string.ui_resources_listing_showing: StringResource by lazy {
      StringResource("string:ui_resources_listing_showing", "ui_resources_listing_showing", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26720, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25484, 84),
      ))
    }

@delegate:ResourceContentHash(-235_470_579)
internal val Res.string.ui_resources_splash_desc: StringResource by lazy {
      StringResource("string:ui_resources_splash_desc", "ui_resources_splash_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 26809, 244),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25569, 208),
      ))
    }

@delegate:ResourceContentHash(-844_214_366)
internal val Res.string.ui_resources_splash_title: StringResource by lazy {
      StringResource("string:ui_resources_splash_title", "ui_resources_splash_title", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27054, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25778, 49),
      ))
    }

@delegate:ResourceContentHash(-2_080_705_471)
internal val Res.string.ui_target_application: StringResource by lazy {
      StringResource("string:ui_target_application", "ui_target_application", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27159, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25875, 45),
      ))
    }

@delegate:ResourceContentHash(-2_079_781_896)
internal val Res.string.ui_target_applications: StringResource by lazy {
      StringResource("string:ui_target_applications", "ui_target_applications", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27112, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25828, 46),
      ))
    }

@delegate:ResourceContentHash(-1_238_941_292)
internal val Res.string.ui_target_campaign: StringResource by lazy {
      StringResource("string:ui_target_campaign", "ui_target_campaign", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27245, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25961, 38),
      ))
    }

@delegate:ResourceContentHash(-1_238_925_862)
internal val Res.string.ui_target_campaigns: StringResource by lazy {
      StringResource("string:ui_target_campaigns", "ui_target_campaigns", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27205, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25921, 39),
      ))
    }

@delegate:ResourceContentHash(-1_995_450_493)
internal val Res.string.ui_target_companies: StringResource by lazy {
      StringResource("string:ui_target_companies", "ui_target_companies", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27284, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26000, 39),
      ))
    }

@delegate:ResourceContentHash(-1_995_335_475)
internal val Res.string.ui_target_company: StringResource by lazy {
      StringResource("string:ui_target_company", "ui_target_company", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27320, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26040, 37),
      ))
    }

@delegate:ResourceContentHash(1_269_429_100)
internal val Res.string.ui_target_device: StringResource by lazy {
      StringResource("string:ui_target_device", "ui_target_device", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27392, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26116, 32),
      ))
    }

@delegate:ResourceContentHash(-2_800_520)
internal val Res.string.ui_target_devices: StringResource by lazy {
      StringResource("string:ui_target_devices", "ui_target_devices", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27354, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26078, 37),
      ))
    }

@delegate:ResourceContentHash(-1_385_667_318)
internal val Res.string.ui_target_location: StringResource by lazy {
      StringResource("string:ui_target_location", "ui_target_location", setOf(
        ResourceItem(setOf(LanguageQualifier("hr"), ), "${MD}values-hr/strings.commonMain.cvr", 27469, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26189, 38),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("ui_locations_detail_btn_delete", Res.string.ui_locations_detail_btn_delete)
  map.put("ui_locations_detail_btn_edit", Res.string.ui_locations_detail_btn_edit)
  map.put("ui_locations_detail_delete_confirm_message", Res.string.ui_locations_detail_delete_confirm_message)
  map.put("ui_locations_detail_delete_confirm_title", Res.string.ui_locations_detail_delete_confirm_title)
  map.put("ui_locations_detail_delete_failed", Res.string.ui_locations_detail_delete_failed)
  map.put("ui_locations_detail_devices_count", Res.string.ui_locations_detail_devices_count)
  map.put("ui_locations_detail_search_hint", Res.string.ui_locations_detail_search_hint)
  map.put("ui_locations_details_indoor_nodes", Res.string.ui_locations_details_indoor_nodes)
  map.put("ui_locations_details_offline_devices", Res.string.ui_locations_details_offline_devices)
  map.put("ui_locations_details_online_devices", Res.string.ui_locations_details_online_devices)
  map.put("ui_locations_details_outdoor_nodes", Res.string.ui_locations_details_outdoor_nodes)
  map.put("ui_locations_edit_btn_add_range", Res.string.ui_locations_edit_btn_add_range)
  map.put("ui_locations_edit_btn_save", Res.string.ui_locations_edit_btn_save)
  map.put("ui_locations_edit_halted", Res.string.ui_locations_edit_halted)
  map.put("ui_locations_edit_label_address", Res.string.ui_locations_edit_label_address)
  map.put("ui_locations_edit_label_name", Res.string.ui_locations_edit_label_name)
  map.put("ui_locations_edit_label_opening_hours", Res.string.ui_locations_edit_label_opening_hours)
  map.put("ui_locations_edit_placeholder_address", Res.string.ui_locations_edit_placeholder_address)
  map.put("ui_locations_edit_range_to", Res.string.ui_locations_edit_range_to)
  map.put("ui_locations_edit_remove_range", Res.string.ui_locations_edit_remove_range)
  map.put("ui_locations_edit_time", Res.string.ui_locations_edit_time)
  map.put("ui_locations_listing_btn_new", Res.string.ui_locations_listing_btn_new)
  map.put("ui_locations_listing_header_devices", Res.string.ui_locations_listing_header_devices)
  map.put("ui_locations_listing_header_id", Res.string.ui_locations_listing_header_id)
  map.put("ui_locations_listing_header_name_address", Res.string.ui_locations_listing_header_name_address)
  map.put("ui_locations_listing_search_placeholder", Res.string.ui_locations_listing_search_placeholder)
  map.put("ui_locations_listing_showing", Res.string.ui_locations_listing_showing)
  map.put("ui_locations_splash_desc", Res.string.ui_locations_splash_desc)
  map.put("ui_locations_splash_title", Res.string.ui_locations_splash_title)
  map.put("ui_login_access", Res.string.ui_login_access)
  map.put("ui_login_btn_authorize", Res.string.ui_login_btn_authorize)
  map.put("ui_login_change_password_btn_cancel", Res.string.ui_login_change_password_btn_cancel)
  map.put("ui_login_change_password_btn_confirm", Res.string.ui_login_change_password_btn_confirm)
  map.put("ui_login_change_password_desc", Res.string.ui_login_change_password_desc)
  map.put("ui_login_change_password_error", Res.string.ui_login_change_password_error)
  map.put("ui_login_change_password_label_new", Res.string.ui_login_change_password_label_new)
  map.put("ui_login_change_password_label_repeat", Res.string.ui_login_change_password_label_repeat)
  map.put("ui_login_change_password_placeholder_new", Res.string.ui_login_change_password_placeholder_new)
  map.put("ui_login_change_password_placeholder_repeat", Res.string.ui_login_change_password_placeholder_repeat)
  map.put("ui_login_change_password_title", Res.string.ui_login_change_password_title)
  map.put("ui_login_invalid", Res.string.ui_login_invalid)
  map.put("ui_login_password", Res.string.ui_login_password)
  map.put("ui_login_username", Res.string.ui_login_username)
  map.put("ui_logout_dialog_btn_confirm", Res.string.ui_logout_dialog_btn_confirm)
  map.put("ui_logout_dialog_btn_dismiss", Res.string.ui_logout_dialog_btn_dismiss)
  map.put("ui_logout_dialog_message", Res.string.ui_logout_dialog_message)
  map.put("ui_logout_dialog_title", Res.string.ui_logout_dialog_title)
  map.put("ui_resources_detail_aspect_ratio", Res.string.ui_resources_detail_aspect_ratio)
  map.put("ui_resources_detail_btn_convert_video", Res.string.ui_resources_detail_btn_convert_video)
  map.put("ui_resources_detail_btn_delete", Res.string.ui_resources_detail_btn_delete)
  map.put("ui_resources_detail_btn_download", Res.string.ui_resources_detail_btn_download)
  map.put("ui_resources_detail_conversion", Res.string.ui_resources_detail_conversion)
  map.put("ui_resources_detail_conversion_started", Res.string.ui_resources_detail_conversion_started)
  map.put("ui_resources_detail_conversion_title", Res.string.ui_resources_detail_conversion_title)
  map.put("ui_resources_detail_date_added", Res.string.ui_resources_detail_date_added)
  map.put("ui_resources_detail_delete_btn_confirm", Res.string.ui_resources_detail_delete_btn_confirm)
  map.put("ui_resources_detail_delete_btn_dismiss", Res.string.ui_resources_detail_delete_btn_dismiss)
  map.put("ui_resources_detail_delete_confirm_message", Res.string.ui_resources_detail_delete_confirm_message)
  map.put("ui_resources_detail_delete_confirm_title", Res.string.ui_resources_detail_delete_confirm_title)
  map.put("ui_resources_detail_description", Res.string.ui_resources_detail_description)
  map.put("ui_resources_detail_dominant_palette", Res.string.ui_resources_detail_dominant_palette)
  map.put("ui_resources_detail_duration", Res.string.ui_resources_detail_duration)
  map.put("ui_resources_detail_file_name", Res.string.ui_resources_detail_file_name)
  map.put("ui_resources_detail_file_size", Res.string.ui_resources_detail_file_size)
  map.put("ui_resources_detail_file_type", Res.string.ui_resources_detail_file_type)
  map.put("ui_resources_detail_info", Res.string.ui_resources_detail_info)
  map.put("ui_resources_detail_metadata_tags", Res.string.ui_resources_detail_metadata_tags)
  map.put("ui_resources_detail_no_description", Res.string.ui_resources_detail_no_description)
  map.put("ui_resources_detail_orientation", Res.string.ui_resources_detail_orientation)
  map.put("ui_resources_detail_pages", Res.string.ui_resources_detail_pages)
  map.put("ui_resources_detail_resolution", Res.string.ui_resources_detail_resolution)
  map.put("ui_resources_detail_status_fail", Res.string.ui_resources_detail_status_fail)
  map.put("ui_resources_detail_status_processing", Res.string.ui_resources_detail_status_processing)
  map.put("ui_resources_detail_status_ready", Res.string.ui_resources_detail_status_ready)
  map.put("ui_resources_detail_technical_specs", Res.string.ui_resources_detail_technical_specs)
  map.put("ui_resources_detail_unknown", Res.string.ui_resources_detail_unknown)
  map.put("ui_resources_listing_btn_upload", Res.string.ui_resources_listing_btn_upload)
  map.put("ui_resources_listing_filter_opt_all", Res.string.ui_resources_listing_filter_opt_all)
  map.put("ui_resources_listing_filter_opt_horizontal", Res.string.ui_resources_listing_filter_opt_horizontal)
  map.put("ui_resources_listing_filter_opt_image", Res.string.ui_resources_listing_filter_opt_image)
  map.put("ui_resources_listing_filter_opt_pdf", Res.string.ui_resources_listing_filter_opt_pdf)
  map.put("ui_resources_listing_filter_opt_vertical", Res.string.ui_resources_listing_filter_opt_vertical)
  map.put("ui_resources_listing_filter_opt_video", Res.string.ui_resources_listing_filter_opt_video)
  map.put("ui_resources_listing_filter_orientation", Res.string.ui_resources_listing_filter_orientation)
  map.put("ui_resources_listing_filter_type", Res.string.ui_resources_listing_filter_type)
  map.put("ui_resources_listing_no_resources_found", Res.string.ui_resources_listing_no_resources_found)
  map.put("ui_resources_listing_search_pick_placeholder", Res.string.ui_resources_listing_search_pick_placeholder)
  map.put("ui_resources_listing_search_placeholder", Res.string.ui_resources_listing_search_placeholder)
  map.put("ui_resources_listing_showing", Res.string.ui_resources_listing_showing)
  map.put("ui_resources_splash_desc", Res.string.ui_resources_splash_desc)
  map.put("ui_resources_splash_title", Res.string.ui_resources_splash_title)
  map.put("ui_target_application", Res.string.ui_target_application)
  map.put("ui_target_applications", Res.string.ui_target_applications)
  map.put("ui_target_campaign", Res.string.ui_target_campaign)
  map.put("ui_target_campaigns", Res.string.ui_target_campaigns)
  map.put("ui_target_companies", Res.string.ui_target_companies)
  map.put("ui_target_company", Res.string.ui_target_company)
  map.put("ui_target_device", Res.string.ui_target_device)
  map.put("ui_target_devices", Res.string.ui_target_devices)
  map.put("ui_target_location", Res.string.ui_target_location)
}
